import { render, staticRenderFns } from "./DriverStatements.vue?vue&type=template&id=6b2d5e66"
import script from "./DriverStatements.vue?vue&type=script&lang=js"
export * from "./DriverStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports